module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"DisplayVATSwitcher":{"on":"VOC s DPH","off":"VOC bez DPH"}},"en":{}}')
  delete Component.options._Ctor
}
